import { Box, Button, Typography } from "@mui/material";
import RemoveIcon from "@mui/icons-material/RemoveOutlined";
import AddIcon from "@mui/icons-material/AddOutlined";
import { useContext, useEffect, useState } from "react";
import { ActionButton } from "../../../shared/components/table/StyledTable";
import CountProvider, {
  CountContext,
} from "../../../shared/providers/CountProvider";
import {
  DECREMENT_COUNT,
  GET_COUNT,
  INCREMENT_COUNT,
} from "../../../shared/reducer";
import CountEditorDialog from "./CountEditorDialog";

type TCountEditorProps = {
  title: string;
  configDataKey: string;
};

const CountEditor = (props: TCountEditorProps) => (
  <CountProvider>
    <CountEditorConsumer {...props} />
  </CountProvider>
);

/** Counter panel with step controls and an exact-value editor. */
const CountEditorConsumer = ({ title, configDataKey }: TCountEditorProps) => {
  const { state, dispatch } = useContext(CountContext);

  useEffect(() => {
    dispatch({ type: GET_COUNT, key: configDataKey });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDecrementCount = () =>
    dispatch({ type: DECREMENT_COUNT, key: configDataKey });
  const handleIncrementCount = () =>
    dispatch({ type: INCREMENT_COUNT, key: configDataKey });

  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  return (
    <>
      <Box
        sx={{
          height: "100%",
          p: 2,
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 3,
          backgroundColor: "background.paper",
        }}
      >
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: "1.75rem",
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1.2,
            mb: 1.5,
          }}
        >
          {state?.countValue.total ?? "—"}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <ActionButton
            icon={<RemoveIcon />}
            label="Zähler verringern"
            variant="outlined"
            onClick={handleDecrementCount}
          />
          <ActionButton
            icon={<AddIcon />}
            label="Zähler erhöhen"
            variant="outlined"
            onClick={handleIncrementCount}
          />
          <Button
            variant="outlined"
            size="small"
            sx={{ ml: "auto" }}
            onClick={() => setDialogOpen(true)}
          >
            Bearbeiten
          </Button>
        </Box>
      </Box>

      {dialogOpen && (
        <CountEditorDialog
          configDataKey={configDataKey}
          handleCloseDialog={() => setDialogOpen(false)}
        />
      )}
    </>
  );
};

export default CountEditor;
